import React from 'react'
import { NavLink } from 'react-router'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Divider } from '@mui/material'

const ContactsSection = () => {
  return (
    <>
      <Divider />
      <ul>
        <li>
          <NavLink
            id="leftNavContacts"
            to="/contacts"
          >
            <span data-hf="sidebar-icon">
              <FontAwesomeIcon
                icon={['far', 'address-book']}
                size="1x"
                fixedWidth
              />
            </span>
            <span data-hf="sidebar-item-label">Contacts</span>
          </NavLink>
        </li>
      </ul>
    </>
  )
}

export default ContactsSection
